module.exports = __webpack_public_path__ + "img/793-a0e9f3.png";